// eslint-disable-next-line no-restricted-imports
import * as VeeValidate from 'vee-validate';
import {
  MaybeRef,
  MaybeRefOrGetter,
} from 'vue';

export const useField = <
  TValue = unknown,
>(
  path: MaybeRefOrGetter<string>,
  rules?: MaybeRef<VeeValidate.RuleExpression<TValue>>,
  opts?: Partial<VeeValidate.FieldOptions<TValue>>,
): VeeValidate.FieldContext<TValue> => {
  const original = VeeValidate.useField(path, rules, opts);
  const originalValidate = original.validate;
  original.validate = (_opts?: Partial<VeeValidate.ValidationOptions>) => originalValidate(_opts)
    .then((result) => {
      if (result.valid) {
        logger.log({ result }, 'ValidatitonCheckSuccess');
      } else {
        logger.log({ result }, 'ValidationCheckFailure');
      }
      return result;
    })
    .catch((error) => {
      logger.log({ error }, 'UncaughtValidationCheckError');
      throw error;
    });
  return original;
};

type GenericObject = Record<string, unknown>;
type FlattenAndSetPathsType<TRecord, TType> = {
  [K in VeeValidate.Path<TRecord>]: TType;
};
type FormSchema<TValues extends Record<string, unknown>> =
  FlattenAndSetPathsType<TValues, GenericObject | VeeValidate.GenericValidateFunction | string> | undefined;
export const useForm = <
  TValues extends GenericObject = GenericObject,
  TOutput = TValues,
  TSchema extends FormSchema<TValues> | VeeValidate.TypedSchema<TValues, TOutput>
  = FormSchema<TValues> | VeeValidate.TypedSchema<TValues, TOutput>,
>(
  opts?: VeeValidate.FormOptions<TValues, TOutput, TSchema>,
): VeeValidate.FormContext<TValues, TOutput> => {
  const original = VeeValidate.useForm(opts);
  const originalValidate = original.validate;
  original.validate = (_opts?: Partial<VeeValidate.ValidationOptions>) => originalValidate(_opts)
    .then((result) => {
      if (result.valid) {
        logger.log({ result }, 'ValidatitonCheckSuccess');
      } else {
        logger.log({ result }, 'ValidationCheckFailure');
      }
      return result;
    })
    .catch((error) => {
      logger.log({ error }, 'UncaughtValidationCheckError');
      throw error;
    });
  return original;
};
